import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import { TypedMemo } from '../../../common/types';
import { catalogSongMessages } from './catalogSongMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from './SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MasterProgressProps {
  /** The first line, for example the file name or "Saving to Halcyon" (design k3). */
  title: string;
  /** 0..100 while the file goes up; null after the upload, while Music24 reads the song. */
  progress: number | null;
  /** The second line after the upload. */
  note?: string;
  /** Shows Stop while the parts go up (the Stop of design h4). */
  onStop?: () => void;
}

/** The progress line of a master upload (designs f1, k3). */
const MasterProgressComponent: React.FC<MasterProgressProps> = ({ title, progress, note, onStop }) => {
  const intl = useIntl();

  return (
    <div className={clsx(styles.songOk, styles.songBusy)} role="status">
      <FontAwesomeIcon icon={faSpinnerThird} spin />
      <div className={styles.grow}>
        <span className={styles.strong}>{title}</span>
        <span className={styles.mono}>
          {progress === null ? note : intl.formatMessage(catalogSongMessages.uploading, { percent: progress })}
        </span>
        {progress !== null && (
          <span className={styles.bar}>
            <i style={{ width: `${progress}%` }} />
          </span>
        )}
      </div>
      {onStop !== undefined && (
        <button type="button" className={styles.linkButton} onClick={onStop}>
          {intl.formatMessage(catalogSongMessages.stop)}
        </button>
      )}
    </div>
  );
};

export const MasterProgress = TypedMemo(MasterProgressComponent);
